import { useAuthContext } from '@asgardeo/auth-react';
import React, { useState } from 'react';

function SigninButton() {
  const [isClicked, setIsClicked] = useState(false);
  const { signIn } = useAuthContext();
  window.dataLayer = window.dataLayer || [];

  const handleClick = () => {
    setIsClicked(!isClicked);
    const urlString = window.location.search;
    if (urlString) {
      sessionStorage.setItem('urlString', urlString);
    }
    const currentPath = window.location.pathname;
    sessionStorage.setItem('redirectAfterLogin', currentPath);
    signIn();
    window.dataLayer.push({
      event: 'login',
      event_category: 'User',
      event_label: 'Successful Login',
    });
  };

  return (
    <div className="flex items-center whitespace-nowrap">
      <button
        onClick={handleClick}
        className="border border-pl-accent text-pl-accent bg-transparent hover:bg-pl-accent hover:text-white rounded-pl text-13 md:text-14 font-semibold px-3 md:px-4 h-[32px] md:h-[36px] transition-colors duration-150"
      >
        Sign in
      </button>
    </div>
  );
}

export default SigninButton;
